import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/RazorpayPayment.css';

const RazorpayPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    orderId: '',
    amount: 0,
  });

  useEffect(() => {
    if (location.state) {
      const { orderId, amount } = location.state;
      setOrderDetails({ orderId, amount });
    } else {
      setPaymentStatus('Order details not found.');
    }
  }, [location.state]);

  const handlePayment = async () => {
    setIsLoading(true);
    setPaymentStatus('');

    try {
      // Step 1: Create an order on the backend
      const orderResponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/payments/create-order`, {
        amount: orderDetails.amount,
        currency: 'INR',
        orderId: orderDetails.orderId,
      });

      const { id: razorpayOrderId, amount: razorpayAmount, currency } = orderResponse.data;

      if (!razorpayOrderId || !razorpayAmount) {
        setPaymentStatus('Failed to create order on backend.');
        return;
      }

      // Step 2: Configure Razorpay options
      const options = {
        key: 'rzp_test_LlVhY9lwAG5Yd4', // Replace with Razorpay Key ID
        amount: razorpayAmount * 100, // Razorpay expects the amount in paise
        currency,
        name: 'Your Company Name',
        description: 'Order Payment',
        order_id: razorpayOrderId,
        handler: async (response) => {
          const { razorpay_order_id, razorpay_payment_id, razorpay_signature } = response;

          try {
            const verifyResponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/payments/verify-payment`, {
              razorpay_order_id,
              razorpay_payment_id,
              razorpay_signature,
              orderId: orderDetails.orderId,
            });

            if (verifyResponse.status === 200) {
              setPaymentStatus('Payment successful!');
              navigate('/payment-success'); // Redirect to success page
            } else {
              setPaymentStatus('Payment verification failed.');
            }
          } catch (error) {
            setPaymentStatus('Payment verification failed.');
          }
        },
        prefill: {
          name: 'John Doe',
          email: 'john.doe@example.com',
          contact: '9999999999',
        },
        theme: {
          color: '#F37254',
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      setPaymentStatus('Payment failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!orderDetails.orderId || !orderDetails.amount) {
    return <div>{paymentStatus || 'Loading order details...'}</div>;
  }

  return (
    <div className="payment-container">
      <h2>Razorpay Payment</h2>
      <p><strong>Order ID:</strong> {orderDetails.orderId}</p>
      <p><strong>Amount:</strong> ₹{orderDetails.amount}</p>
      <button onClick={handlePayment} disabled={isLoading}>
        {isLoading ? 'Processing...' : 'Pay Now'}
      </button>
      {paymentStatus && <p>{paymentStatus}</p>}
    </div>
  );
};

export default RazorpayPayment;
